import React from 'react';
import NavBar from './NavBar';
import { Box, ThemeProvider } from '@mui/material';
import DrawerExtend from './Common/DrawerExtend';
import { customTheme } from '../utils';
import { useOnlineStatus } from '../hooks';

const childrenStyle = {
    flexGrow: 1,
    p: { xs: 0, md: 2, lg: 3 },
    position: 'relative',
    marginLeft: { xs: 0, md: '16vw', lg: '12vw' }
};

const Layout = ({
  logout,
  newInstance,
  children,
  showDemoVideo,
  renderAlert,
  alertText,
  alertType,
  setAlert,
  customAlertStyle,
}) => {
    const isOnline = useOnlineStatus();
    return (
        <ThemeProvider theme={customTheme}>
            <NavBar
                logout={logout}
                newInstance={newInstance}
                showDemoVideo={showDemoVideo}
                renderAlert={renderAlert}
                alertText={alertText}
                alertType={alertType}
                setAlert={setAlert}
                customAlertStyle={customAlertStyle}
                isOnline={isOnline}
            />
            <DrawerExtend />
            <Box
                component="main"
                sx={childrenStyle}
                className={isOnline ? '' : 'offlineOverlay'}
            >
                {children}
            </Box>
        </ThemeProvider>
    );
};

export default Layout;
